import React from 'react'
import PropTypes from 'prop-types'
import compose from 'recompose/compose'
import withWidth from 'material-ui/utils/withWidth'
import {withStyles} from 'material-ui/styles/index'
import MUIDrawer from 'react-motion-drawer'
import Paper from 'material-ui/Paper'
import List, {ListItem, ListItemText} from 'material-ui/List'
import Divider from 'material-ui/Divider'
import Typography from 'material-ui/Typography'
import IconButton from 'material-ui/IconButton'
import AccountCircleIcon from 'material-ui-icons/AccountCircle'
import LabelIcon from 'material-ui-icons/Label'
import MUIAvatar from 'material-ui/Avatar'
import {Button} from '../../../components'


const styles = (theme) => ({
  drawer: {
    boxShadow: theme.shadows[8],
  },
  container: {
    minHeight: '100%',
  },
  topContainer: {
    padding: '32px 16px',
    boxSizing: 'border-box',
    textAlign: 'center',
    background: `linear-gradient(135deg, ${theme.palette.gradient.start} 0%, ${theme.palette.gradient.end} 100%)`,
  },
  divider: {
    width: '90%',
    margin: '10px auto',
  },
  avatarContainer: {
    width: 82,
    height: 82,
    margin: '32px 0 24px 0',
    boxShadow: theme.shadows[4],
  },
  avatar: {
    backgroundColor: 'rgba(0,0,0,.20)',
  },
  avatarRoot: {
    width: 82,
    height: 82,
  },
  actionContainer: {
    marginTop: 20,
  },
  items: {
    fontSize: 12,
  },
  labelIcon: {
    position: 'relative',
    top: 7,
    color: '#FFF',
  },
})

const Drawer = ({classes, isOpen, onChange, items, user, action}) => (
  <MUIDrawer open={isOpen} onChange={onChange} right={true} className={classes.drawer}>
    <Paper className={classes.container}>
      <div className={classes.topContainer}>
        <IconButton onClick={user.onClick} className={classes.avatarContainer}>
          {user.picture && user.picture !== ''
            ? <MUIAvatar className={classes.avatar} classes={{root: classes.avatarRoot}} src={user.picture} alt="user"/>
            :
            <MUIAvatar className={classes.avatar} classes={{root: classes.avatarRoot}}><AccountCircleIcon/></MUIAvatar>
          }
        </IconButton>
        <Typography variant={'headline'} style={{color: '#FFF'}}>¡Hola {user.name}!</Typography>
        <div>
          <Typography variant={'body1'} className={classes.items}>
            <LabelIcon className={classes.labelIcon}/>
            <span style={{fontWeight: 500}}> {user.items}</span>
            <span style={{color: '#FFF'}}> ítems</span>
          </Typography>
        </div>
        <div className={classes.actionContainer}>
          <Button variant={'primary'} onClick={action.onClick} fullWidth={true}>{action.label}</Button>
        </div>
      </div>
      <List>
        {items.map((item, index) =>
          item.isDivider === true ? (
            <Divider key={index} className={classes.divider}/>
          ) : (
            <ListItem key={index} button onClick={item.onClick} disabled={item.disabled}>
              <ListItemText
                primary={<Typography variant={'body2'} color={'textSecondary'}>{item.label}</Typography>}
                disableTypography={true}
              />
            </ListItem>
          ),
        )}
      </List>
    </Paper>
  </MUIDrawer>
)

Drawer.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired,
  items: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string,
    onClick: PropTypes.func,
    isDivider: PropTypes.bool,
    disabled: PropTypes.bool,
  })),
  user: PropTypes.shape({
    name: PropTypes.string.isRequired,
    picture: PropTypes.string,
    items: PropTypes.number.isRequired,
    onClick: PropTypes.func.isRequired,
  }).isRequired,
  action: PropTypes.shape({
    label: PropTypes.string.isRequired,
    onClick: PropTypes.func.isRequired,
  }),
}

export default compose(withStyles(styles, {withTheme: true}), withWidth())(Drawer)



// WEBPACK FOOTER //
// ./src/sections/header/components/drawer.js